import {
  AROM_ASSESSMENT,
  FUNCTIONAL_REACH_ASSESSMENT,
  mCTSIB_ASSESSMENT,
} from "../../models/Enums";
import { AssessmentKey, FRAssessmentKey } from "./arom-assessment-gif";

interface Props {
  assessment: AssessmentKey | FRAssessmentKey | mCTSIB_ASSESSMENT;
}

const assesmentData = {
  [AROM_ASSESSMENT.Shoulder_AAA]: {
    heading: "Phase 1 Complete!",
  },
  [AROM_ASSESSMENT.Left_Shoulder_FAE]: {
    heading: "Saved!",
  },
  [AROM_ASSESSMENT.Right_Shoulder_FAE]: {
    heading: "Saved!",
  },
  [AROM_ASSESSMENT.Left_Elbow_FAE]: {
    heading: "Saved!",
  },
  [AROM_ASSESSMENT.Right_Elbow_FAE]: {
    heading: "Saved!",
  },
  [AROM_ASSESSMENT.Left_Shoulder_IAE_Rotation]: {
    heading: "Phase 3 Complete!",
  },
  [AROM_ASSESSMENT.Right_Shoulder_IAE_Rotation]: {
    heading: "Phase 2 Complete!",
  },
};

const mCTSIBAssesmentData = {
  [mCTSIB_ASSESSMENT.Open_Eyes]: {
    heading: "Phase 1 Complete!",
  },
  [mCTSIB_ASSESSMENT.Closed_Eyes]: {
    heading: "Phase 2 Complete!",
  },
  [mCTSIB_ASSESSMENT.Foam_Open_Eyes]: {
    heading: "Phase 3 Complete!",
  },
  [mCTSIB_ASSESSMENT.Foam_Closed_Eyes]: {
    heading: "Phase 4 Complete!",
  },
};

const FRAssesmentData = {
  [FUNCTIONAL_REACH_ASSESSMENT.Left_Reach]: {
    heading: "Phase 1 Complete!",
  },
  [FUNCTIONAL_REACH_ASSESSMENT.Right_Reach]: {
    heading: "Phase 2 Complete!",
  },
  [FUNCTIONAL_REACH_ASSESSMENT.Forward_Reach]: {
    heading: "Phase 3 Complete!",
  },
};

const AROMCompletionModal: React.FC<Props> = ({ assessment }) => {
  return (
    <>
      <div
        style={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          alignContent: "center",
          justifyContent: "center",
        }}
      >
        <p
          style={{
            fontSize: "55px",
            fontWeight: "700",
            lineHeight: "74.9px",
            textAlign: "center",
            color: "white",
            paddingBottom: "56px",
          }}
        >
          {sessionStorage.getItem("selectedAssesment") === "55"
            ? assesmentData[assessment as AssessmentKey].heading
            : sessionStorage.getItem("selectedAssesment") === "1"
            ? mCTSIBAssesmentData[assessment as mCTSIB_ASSESSMENT].heading
            : FRAssesmentData[assessment as FRAssessmentKey].heading}
        </p>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="401"
          height="400"
          viewBox="0 0 401 400"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M200.922 0C90.4649 0 0.921875 89.543 0.921875 200C0.921875 310.457 90.4649 400 200.922 400C311.379 400 400.922 310.457 400.922 200C400.922 89.543 311.379 0 200.922 0Z"
            fill="#0F854C"
          />
          <path
            d="M275.922 150L175.922 250L125.922 200"
            stroke="white"
            stroke-width="24"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </>
  );
};
export default AROMCompletionModal;
